import React from "react";

export const Vision = (props) => {
  return (
    <div id="vision">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Our Vision</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>What's your mission?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>
                            <i className="fa fa-check"></i>
                            <span>{d}</span>
                          </li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}>
                            <i className="fa fa-check"></i>
                            <span>{d}</span>
                          </li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 big-img-container">
            <img
              src="img/mission.avif"
              className="img-responsive big-img"
              alt="Team discussing vision"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
